import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getTripById } from "../../services/tripServices";
import NewTripForm from "./newTripForm";

export default function EditTrip() {
    const { tripId } = useParams();

    const [tripData, setTripData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getTripById(tripId).then(data => {
            setTripData(data);
            setLoading(false);
        }).catch(err => {
            console.error("Failed to fetch trip:", err);
        });
    }, [tripId]);

    return loading ? (
        <p>Loading...</p>
    ) : <NewTripForm initialData={tripData} />

}